import { Template } from "@zapier/client";
import { BetaDataTableCell as Cell } from "@zapier/design-system";
import {
  OwnerCell,
  Row,
  ServiceIconsWithTooltip,
  TitleCell,
} from "@zapier/shared";
import { AssetTypes, getAssetIcon } from "@zapier/utils";
import styles from "./TemplatesTable.module.css";
import { useTemplateRow } from "./useTemplateRow";

interface TemplateRowProps {
  template: Template;
  searchQuery?: string | null;
  onShareTemplate?: () => void;
  onDeleteTemplate?: () => void;
  onChangeOwnerTemplate?: () => void;
  onDuplicateTemplate?: () => void;
}

const TemplateRow = ({
  template,
  searchQuery,
  onShareTemplate,
  onDeleteTemplate,
  onChangeOwnerTemplate,
  onDuplicateTemplate,
}: TemplateRowProps) => {
  const {
    menuItems,
    kebabMenuLabel,
    enablePermissionsCheck,
    handleOpenTemplateDetails,
    shareMessage,
  } = useTemplateRow({
    template,
    onShareTemplate,
    onDeleteTemplate,
    onChangeOwnerTemplate,
    onDuplicateTemplate,
  });

  return (
    <Row
      allowsSelection={false}
      id={template.id}
      assetType={AssetTypes.Template}
      menuItems={menuItems}
      kebabMenuLabel={kebabMenuLabel}
      onOpenMenu={enablePermissionsCheck}
      shareMessage={shareMessage}
      showFavoriteButton={false}
      showShareButton={false}
      showOptions={true}
    >
      <TitleCell
        id={template.id}
        title={template.name}
        icon={getAssetIcon(AssetTypes.Template)}
        subtitle={template.subtitle || undefined}
        className={styles.titleCell}
        searchQuery={searchQuery}
        assetType={AssetTypes.Template}
        onClick={handleOpenTemplateDetails}
      />
      <Cell className={styles.appsColumn}>
        <ServiceIconsWithTooltip
          appIds={(template.apps?.filter(Boolean) as string[]) || []}
        />
      </Cell>
      <OwnerCell
        name={
          template.owner && "fullName" in template.owner
            ? template.owner.fullName
            : undefined
        }
        photoUrl={
          template.owner && "fullName" in template.owner
            ? (template.owner.photoUrl ?? undefined)
            : undefined
        }
        avatarClassName={styles.ownerAvatarCentered}
      />
    </Row>
  );
};

export default TemplateRow;
